import { Injectable } from '@angular/core';
import { People } from '../models/people';
import { Team } from '../models/team';

@Injectable({
    providedIn: 'root',
})
export class StatisticsService {

    getTeamTypeChartData(teams: Team[]){
        const teamTypeChartData: { [teamType: string]: number } = {};

        teams.forEach((team) => {
            if (teamTypeChartData[team.teamType]) {
            teamTypeChartData[team.teamType]++;
            } else {
            teamTypeChartData[team.teamType] = 1;
            }
        });

        return teamTypeChartData;
    }


    getContractorChartData(peoples: People[]){

        const contractorCount = peoples.filter(people => people.is_contractor).length;
        const internCount = peoples.length - contractorCount;
        return [internCount, contractorCount];

    }
}